import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=258784da&scoped=true&"
import script from "./Recommendations.vue?vue&type=script&lang=js&"
export * from "./Recommendations.vue?vue&type=script&lang=js&"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=258784da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258784da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/recommendations/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258784da')) {
      api.createRecord('258784da', component.options)
    } else {
      api.reload('258784da', component.options)
    }
    module.hot.accept("./Recommendations.vue?vue&type=template&id=258784da&scoped=true&", function () {
      api.rerender('258784da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recommendations.vue"
export default component.exports